import Text from './Text';
import withHtmlSafe from '../withHtmlSafe';
export default withHtmlSafe(Text);